import Axios from "axios";

import {
  GET_T_C_LIST_ADMIN,
  GET_EXCEPTION_T_C_LIST_ADMIN,
} from "../../mutation-types";

import {
  getTClistAdmin,
  getTCexceptionAdmin,
  storeTCexceptionAdmin,
  destroyTCexceptionAdmin,
} from "../../api";

const state = {
  tcList: [],
  tcExceptionList: [],
};
const getters = {
  getTCData(state) {
    return state.tcList;
  },
  getTCExceptionData(state) {
    return state.tcExceptionList;
  },
};
// mutations
const mutations = {
  [GET_T_C_LIST_ADMIN](state, response) {
    state.tcList = response;
  },
  [GET_EXCEPTION_T_C_LIST_ADMIN](state, response) {
    state.tcExceptionList = response;
  },
};
// Actions
const actions = {
  getTCListAdmin({ commit }, date) {
    return Axios.get(getTClistAdmin, { params: date }).then(function(response) {
      var routine = response.data;
      commit("GET_T_C_LIST_ADMIN", routine);
      return routine;
    });
  },

  getTCExceptionListAdmin({ commit }, date) {
    return Axios.get(getTCexceptionAdmin, { params: date }).then(function(
      response,
    ) {
      var routine = response.data;
      commit("GET_EXCEPTION_T_C_LIST_ADMIN", routine);
      return routine;
    });
  },

  saveTCException({ commit }, formData) {
    return new Promise(function(resolve, reject) {
      commit("SET_LOADING", { color: "primary" });

      Axios.post(storeTCexceptionAdmin, formData)
        .then(function(response) {
          if (response.data.status === "success") {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "TC Exception saved successfully",
              color: "green",
            });

            resolve(response);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Something went wrong",
              color: "red",
            });

            reject(response);
          }
        })
        .catch(function(error) {
          var message = "Something went wrong while saving TC Exception";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: message,
            color: "red",
          });

          reject(error);
        })
        .then(function() {
          commit("UNSET_LOADING");
        });
    });
  },

  deleteException({ commit }, id) {
    return new Promise(function(resolve, reject) {
      commit("SET_LOADING", { color: "primary" });

      Axios.delete(destroyTCexceptionAdmin + "/" + id)
        .then(function(response) {
          if (response.data.status === "success") {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "TC Exception deleted successfully",
              color: "green",
            });

            resolve(response);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Something went wrong",
              color: "red",
            });

            reject(response);
          }
        })
        .catch(function(error) {
          var message = "Something went wrong while deleting TC Exception";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: message,
            color: "red",
          });

          reject(error);
        })
        .then(function() {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
